import React from "react";

const ServicesSection = () => {
  return (
    <>
      <style>{`
        .services-section {
          background: #EFFFE1;
          padding: 70px 0;
        }

        .services-container {
          max-width: 1100px;
          margin: auto;
          padding: 0 20px;
        }

        /* HEADER */
        .services-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 60px;
          flex-wrap: wrap;
          gap: 20px;
        }

        .services-header h2 {
          font-size: 42px;
          color: #0F3D2E;
          font-weight: 700;
          max-width: 520px;
          line-height: 1.3;
        }

        .services-btn {
          background: #7ED957;
          padding: 14px 26px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
          font-weight: 500;
          transition: 0.3s;
        }

        .services-btn:hover {
          background: #D4AF37;
        }

        /* GRID */
        .services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        /* ✅ SAME BG CARDS WITH DEPTH */
.service-card {
  background: #EFFFE1; /* same as section */

  padding: 35px 28px;
  border-radius: 18px;

  border: 2px solid #0F3D2E; /* ✅ DARK GREEN OUTLINE */

  min-height: 360px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  transition: 0.3s ease;
}

        /* HOVER */
.service-card:hover {
  transform: translateY(-5px);
  border-color: #D4AF37; /* gold highlight on hover */
}

        /* ICON */
        .icon {
          width: 65px;
          height: 65px;
          background: #DFF5C8; /* slightly darker for contrast */
          border-radius: 50%;

          display: flex;
          align-items: center;
          justify-content: center;

          margin-bottom: 20px;
          font-size: 26px;
        }

        .service-card h3 {
          font-size: 20px;
          margin-bottom: 10px;
          color: #0F3D2E;
        }

        .service-card p {
          font-size: 15px;
          color: #555;
          margin-bottom: 15px;
        }

        .service-points {
          list-style: none;
          padding: 0;
          margin-bottom: 20px;
        }

        .service-points li {
          font-size: 14px;
          color: #333;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .dot {
          width: 6px;
          height: 6px;
          background: #1E8449;
          border-radius: 50%;
        }

        .read-more {
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .services-grid {
            grid-template-columns: 1fr;
          }

          .services-header h2 {
            font-size: 28px;
          }

          .service-card {
            min-height: auto;
          }
        }
      `}</style>

      <section className="services-section">
        <div className="services-container">

          <div className="services-header">
            <h2>
              From Tax Filing to Compliance,
              We’ve Got You Covered.
            </h2>
          </div>

          <div className="services-grid">

            {/* ITR */}
            <div className="service-card">
              <div>
                <div className="icon">📄</div>
                <h3>Income Tax Filing (ITR)</h3>
                <p>Accurate and hassle-free tax filing services.</p>

                <ul className="service-points">
                  <li><span className="dot"></span> Salaried & Business ITR</li>
                  <li><span className="dot"></span> Capital Gain Filing</li>
                  <li><span className="dot"></span> Tax Saving Optimization</li>
                  <li><span className="dot"></span> Notice Handling</li>
                </ul>
              </div>

              <div className="read-more">Starting ₹500 →</div>
            </div>

            {/* GST */}
            <div className="service-card">
              <div>
                <div className="icon">🧾</div>
                <h3>GST Filing & Compliance</h3>
                <p>End-to-end GST solutions for your business.</p>

                <ul className="service-points">
                  <li><span className="dot"></span> GST Registration</li>
                  <li><span className="dot"></span> Monthly Returns</li>
                  <li><span className="dot"></span> GST Reconciliation</li>
                  <li><span className="dot"></span> Notice Reply</li>
                </ul>
              </div>

              <div className="read-more">From ₹1,000/month →</div>
            </div>

            {/* TDS */}
            <div className="service-card">
              <div>
                <div className="icon">📊</div>
                <h3>TDS / TCS Services</h3>
                <p>Stay compliant with proper TDS/TCS management.</p>

                <ul className="service-points">
                  <li><span className="dot"></span> Quarterly Returns</li>
                  <li><span className="dot"></span> Monthly Monitoring</li>
                  <li><span className="dot"></span> Compliance Advisory</li>
                  <li><span className="dot"></span> Notice Handling</li>
                </ul>
              </div>

              <div className="read-more">From ₹1,000/quarter →</div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesSection;